import { FocusIcon, FocusIconGlyph } from '../elements/focus-icon';
export var KeyIssueIcon = FocusIcon;
export var KeyIssueIconGlyph = FocusIconGlyph;